import { useAuthorization } from '../../../authorization/useAuthorization';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { ACCESS } from '../../../constants/authz/accessPresets.constants';
import { globalpermissions } from '../../../Services/Permission';

/**
 * User management CRUD permissions — RBAC v2 object grants with legacy fallback.
 */
export default function useUserManagementPermissions() {
  const { can, isAuthzV2Enabled } = useAuthorization();
  const constActions = ConstantActions();

  if (isAuthzV2Enabled) {
    return {
      canView: can(ACCESS.USER_MANAGEMENT_VIEW),
      canCreate: can(ACCESS.USER_CREATE),
      canEdit: can(ACCESS.USER_UPDATE),
      canDelete: can(ACCESS.USER_DELETE),
      canChangePassword: can(ACCESS.USER_UPDATE),
      canUnlock: can(ACCESS.USER_UNLOCK),
      canSetStatus: can(ACCESS.USER_UPDATE),
    };
  }

  const routes = globalpermissions.managementRoutes;
  const canViewList = constActions.userHasPermission([routes.viewUserList]);
  const canCreate = constActions.userHasPermission([routes.createUser]);

  return {
    canView: canViewList,
    canCreate: canCreate || canViewList,
    canEdit: canViewList,
    canDelete: canViewList,
    canChangePassword: canViewList,
    canUnlock: canViewList,
    canSetStatus: canViewList,
  };
}
